import React from 'react';
import { PromptVariableViewModel } from '../../types';
import { ItemListProps } from '../../../commons/components/ItemListAndDetails';
import { GroupItemProps, ItemList } from '../../../commons/components/ItemList';

const SuggestedGroupItem = (props: GroupItemProps) => {
  return (
    <div
      className="variable-list__item-sub-container--suggested"
      data-test="variable-list__item-sub-container--suggested"
    >
      <div className="variable-list__suggested-title">{props.item}</div>
      {props.children}
    </div>
  );
};

export const VariableList = (props: ItemListProps<PromptVariableViewModel>) => {
  return (
    <ItemList
      {...props}
      categoryGetter={(x) => (x.isSuggested ? 'Suggested to fill in' : null)}
      noMenu={true}
      noIcons={true}
      groupItemComponent={SuggestedGroupItem}
    />
  );
};
